var React = require('react');

function UiClose (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close"),React.createElement("path",{"d":"M97.8,90.4c1.7,2.4,1.1,5.7-1.3,7.4c-1.8,1.3-4.3,1.3-6.1,0L49.9,57.7l-40,40.1c-2.1,2.1-5.5,2.1-7.5,0s-2.1-5.5,0-7.5l0,0\n\tL42.6,50L2.3,9.7c-2.1-2.1-2.1-5.5,0-7.5s5.5-2.1,7.5,0l40,40.5L90.1,2.4c2.1-2.1,5.5-2.1,7.6-0.1c2.1,2.1,2.1,5.5,0.1,7.6L57.6,50\n\tL97.8,90.4z","key":1})]);
}

UiClose.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100.1 100.1","style":{"enableBackground":"new 0 0 100.1 100.1"},"xmlSpace":"preserve"};

module.exports = UiClose;

UiClose.default = UiClose;
